export const MAX_PROFILE_IMAGE_BYTES = 1024 * 1024;
export const SUPPORTED_PROFILE_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/webp",
];

export const readProfileImage = (file) => {
  if (!file) return Promise.resolve(null);
  if (!SUPPORTED_PROFILE_IMAGE_TYPES.includes(file.type)) {
    return Promise.reject(
      new Error("Choose a JPEG, PNG, GIF, or WebP image.")
    );
  }
  if (file.size > MAX_PROFILE_IMAGE_BYTES) {
    return Promise.reject(new Error("Profile image must be 1 MB or smaller."));
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error("The image could not be read."));
    reader.readAsDataURL(file);
  });
};
